<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00047 5.14272H3.09431C2.94276 5.14272 2.79741 5.08251 2.69024 4.97535L0.975961 3.26106C0.752805 3.03791 0.752805 2.6761 0.975961 2.45295L2.69024 0.738656C2.79741 0.631492 2.94276 0.571289 3.09431 0.571289H8.00047"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 8.57143H12.9062C13.0577 8.57143 13.2031 8.51122 13.3102 8.40406L15.0245 6.68977C15.2477 6.46662 15.2477 6.10481 15.0245 5.88166L13.3102 4.16737C13.2031 4.06021 13.0577 4 12.9062 4H8"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.00047 11.9997H3.09431C2.94276 11.9997 2.79741 11.9394 2.69024 11.8323L0.975961 10.118C0.752805 9.89484 0.752805 9.53303 0.975961 9.30988L2.69024 7.59559C2.79741 7.48843 2.94276 7.42822 3.09431 7.42822H8.00047"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 0.571289V15.4284"
            stroke="black"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
